import { TEAM_MEMBER_ACTION_NAME } from 'hooks/useSaveUserActivityLog'

type SaveActivityLog = (args: {
  action: string
  target: string
  requestBody: Record<string, unknown>
  statusCode: number
}) => void

export function logSaveTeamMember(
  saveUserActivityLog: SaveActivityLog,
  companyId: number | undefined,
  isEditMode: boolean,
  requestBody: Record<string, unknown>,
  statusCode: number
) {
  saveUserActivityLog({
    action: isEditMode
      ? TEAM_MEMBER_ACTION_NAME.updated_team_member
      : TEAM_MEMBER_ACTION_NAME.created_team_member,
    target: `com_${companyId}`,
    requestBody: {
      name: requestBody.name || '',
      email: requestBody.email || '',
      group_tokens: requestBody.group_tokens || [],
      external_id: requestBody.member_id || '',
    },
    statusCode,
  })
}

export function logDeleteTeamMember(
  saveUserActivityLog: SaveActivityLog,
  companyId: number | undefined,
  memberId: number | string | undefined,
  statusCode: number
) {
  saveUserActivityLog({
    action: TEAM_MEMBER_ACTION_NAME.deleted_team_member,
    target: `com_${companyId}`,
    requestBody: memberId ? { member_id: memberId } : {},
    statusCode,
  })
}

export function logSaveTeamMemberGroup(
  saveUserActivityLog: SaveActivityLog,
  companyId: number | undefined,
  isCreate: boolean,
  requestBody: Record<string, unknown>,
  statusCode: number
) {
  saveUserActivityLog({
    action: isCreate
      ? TEAM_MEMBER_ACTION_NAME.created_team_member_group
      : TEAM_MEMBER_ACTION_NAME.updated_team_member_group,
    target: `com_${companyId}`,
    requestBody,
    statusCode,
  })
}

export function logDeleteTeamMemberGroup(
  saveUserActivityLog: SaveActivityLog,
  companyId: number | undefined,
  groupToken: string | null | undefined,
  statusCode: number
) {
  saveUserActivityLog({
    action: TEAM_MEMBER_ACTION_NAME.deleted_team_member_group,
    target: `com_${companyId}`,
    requestBody: { group_token: groupToken },
    statusCode,
  })
}

export function logMapTeamMember(
  saveUserActivityLog: SaveActivityLog,
  companyId: number | undefined,
  primaryEmail: string,
  emails: string[],
  statusCode: number
) {
  saveUserActivityLog({
    action: TEAM_MEMBER_ACTION_NAME.mapped_team_member,
    target: `com_${companyId}`,
    requestBody: { primary_email: primaryEmail, emails },
    statusCode,
  })
}

export function logMergeTeamMember(
  saveUserActivityLog: SaveActivityLog,
  companyId: number | undefined,
  keptId: number,
  deletedId: number,
  statusCode: number
) {
  saveUserActivityLog({
    action: TEAM_MEMBER_ACTION_NAME.merged_team_member,
    target: `com_${companyId}`,
    requestBody: { kept_id: keptId, deleted_id: deletedId },
    statusCode,
  })
}



// WEBPACK FOOTER //
// ./src/components/TeamMembers/utils.ts